import { render, staticRenderFns } from "./auth-batch.vue?vue&type=template&id=6908f041&scoped=true&"
import script from "./auth-batch.vue?vue&type=script&lang=js&"
export * from "./auth-batch.vue?vue&type=script&lang=js&"
import style0 from "./auth-batch.vue?vue&type=style&index=0&id=6908f041&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6908f041",
  null
  
)

export default component.exports